<template>
  <div>
    <div class="panel">
      <div class="panel-block">
        Sygnalista to osoba, która z uwagi na posiadane informacje dokonuje zgłoszenia zauważonych nieprawidłowości.
        Status sygnalisty uzyska osoba, która dokonuje zgłoszenia różnego
        rodzaju nieprawidłowości, które powinny mieć oparcie w faktach, a które stanowić mogą działania lub zaniechania
        niezgodne z prawem a przez to, w interesie publicznym jest, aby w
        odpowiedni sposób identyfikować i wykrywać takie zachowania a także przeciwdziałać im na przyszłość.
      </div>
    </div>
    <h5 class="has-text-centered">Zgłoszenie nieprawidłowości może nastąpić poprzez odpowiedź na poniższe pytania
      gwarantując usprawnienie jej przetworzenia.</h5>
    <Stage1 class="my-2" @response="stage2 = $event" />
    <transition name="fade" appear>
      <component :is="stage2" class="my-2" @response="saveResponse($event)" />
    </transition>
    <div class="rodo-container">
      <h4>Klauzula informacyjna RODO</h4>
      <div class="rodo-content">
        <p>
          Na podstawie przepisów Rozporządzenia Parlamentu Europejskiego i Rady (EU) 2016/679 z dnia 27 kwietnia 2016
          roku w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu
          takich danych oraz uchylenia dyrektywy 95/46/WE (zwanego dalej „RODO”) informujemy, iż:
        </p>
        <ol>
          <li>
            Administratorem danych osobowych jest Politechnika Poznańska z siedzibą ul.Jacka Rychlewskiego 1, 61-131 Poznań, e-mail: <a href="mailto:biuro.rektora@put.poznan.pl">biuro.rektora@put.poznan.pl</a>, telefon: 61 665 3639.
          </li>
          <li>
            Administrator wyznaczył Inspektora Ochrony Danych – Pana Piotra Otomańskiego, który nadzoruje prawidłowość
            przetwarzania danych osobowych na Politechnice Poznańskiej. Z IOD można kontaktować się mailowo, wysyłając
            wiadomość na adres: <a href="mailto:iod@put.poznan.pl">iod@put.poznan.pl</a>.
          </li>
          <li>
            Dane osobowe będą przetwarzane na podstawie art. 6 ust. 1 lit. c w celu prowadzenia obsługi dotyczącej
            zgłoszeń w przedmiocie naruszeń prawa, w szczególności analizy otrzymanego zgłoszenia oraz prowadzenia
            rejestru
            zgłoszeń naruszeń.
          </li>
          <li>
            Odbiorcami danych mogą być organy publiczne i urzędy państwowe lub inne podmioty upoważnione na podstawie
            przepisów prawa.
          </li>
          <li>
            Administrator będzie przechowywał dane osobowe przez okres 3 lat od dnia przyjęcia zgłoszenia.
          </li>
          <li>
            W związku z przetwarzaniem danych osobowych, osobom, których dane dotyczą, przysługują (na zasadach
            określonych w RODO) następujące uprawnienia: prawo dostępu do treści swoich danych osobowych, sprzeciwu,
            prawo ich sprostowania, usunięcia, przenoszenia oraz ograniczenia przetwarzania oraz prawo do złożenia
            skargi do Prezesa Urzędu Ochrony Danych Osobowych.
          </li>
          <li>
            Dane osobowe nie będą przekazywane do państwa trzeciego lub organizacji międzynarodowej.
          </li>
          <li>
            Podanie danych osobowych jest dobrowolne, ale niezbędne do rozpatrzenia zgłoszenia.
          </li>
          <li>
            Dane osobowe nie będą przetwarzane w sposób zautomatyzowany, w tym również w formie profilowania.
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Main",
    components: {
      Stage1: () => import("@/components/questions/Stage1")
    },
    data() {
      return {
        stage2: null
      }
    },
    methods: {
      saveResponse() {
      }
    }
  }
</script>

<style scoped>
.rodo-container {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 1rem;
  }

.rodo-content {
    flex: 3;
    font-size: 1rem;
    line-height: 1.6;
  }

  .rodo-content p {
    margin-bottom: 1rem;
  }
</style>
